import React from "react"
import config from 'react-global-configuration';
import {  Link } from 'react-router-dom'

import AuthActions from '../../actions/AuthActions'

/*
var getInvoiceState = () => {
  return InvoiceStore.getAll()
}
*/

export default class HeaderAll extends React.Component {

  constructor(){
    super()

    this.state = {

    }
  }

  componentDidMount(){

  }

  componentWillUnmount(){

  }

  logout(){
    AuthActions.logout()
  }

  /* Handlers */


  render(){


    return(
      <header>
          <a href="/club/"><img src={`${process.env.PUBLIC_URL}/images/logo.png`} /></a>
          <nav>
            <div><Link to="/member/">MyPage</Link></div>
            <div><Link to="/member/paid">課金履歴</Link></div>
            <div><Link to="/member/calendar">カレンダー</Link></div>
            <div className="link" onClick={this.logout}>ログアウト</div>
          </nav>
      </header>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/parts/HeaderMember.js